import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LockScreenHyperframe } from '../notifications/LockScreenHyperframe';
import { EASE_OUT } from '../ui/premiumKit';

// 로그인 화면 왼쪽 — 브랜딩·단계별 제목·잠금화면 알림 미리보기 (2026-10-22 AuthPage에서 그대로 옮김: AuthPage 800줄 규칙)
// 2026-11-03 새 디자인(대표 확정 최고 기준, 10/14 안내서): 빛 번짐·글자 그라데이션 대신 흰 글씨 + 회색 둘째 줄,
// 주인공은 실물 미리보기(잠금화면 알림). 글귀는 예전 그대로.
interface AuthBrandingPanelProps {
    step: 'phone' | 'otp';
    isSignUp: boolean;
    phone: string;
}

const LOGO_SRC = 'https://ik.imagekit.io/u9hycyuth/%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA%202025-06-13%20%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE%209.14.59-Photoroom.png?updatedAt=1749816936129';

const Brand: React.FC<{ big?: boolean }> = ({ big }) => (
    <Link to="/" className="inline-flex items-center gap-2.5">
        <span className={`flex items-center justify-center rounded-xl border border-white/[0.10] bg-[#0F0F11] ${big ? 'h-12 w-12' : 'h-9 w-9'}`}>
            <img src={LOGO_SRC} alt="SocialDataLab" className={`object-contain ${big ? 'h-8 w-8' : 'h-6 w-6'}`} />
        </span>
        <span className={`font-bold tracking-tight text-[#FAFAFA] ${big ? 'text-[22px]' : 'text-[16px]'}`}>SocialDataLab</span>
    </Link>
);

export const AuthBrandingPanel: React.FC<AuthBrandingPanelProps> = ({ step, isSignUp, phone }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            initial={reduce ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: EASE_OUT }}
            className="w-full lg:max-w-xl"
        >
            {/* 휴대폰: 맨 위 작은 브랜드 줄 하나 */}
            <div className="lg:hidden">
                <Brand />
            </div>

            {/* PC: 브랜드 + 큰 제목 + 실물 미리보기 */}
            <div className="hidden lg:block">
                <Brand big />

                <div className="mt-12">
                    <h1 className="text-[44px] font-bold text-[#FAFAFA]" style={{ lineHeight: 1.18, letterSpacing: '-0.03em', textWrap: 'balance' as never }}>
                        {step === 'phone' ? (
                            isSignUp ? (
                                <>
                                    <span>간편하게</span>{' '}
                                    <span className="text-[#71717A]">시작하세요</span>
                                </>
                            ) : (
                                <>
                                    <span>다시 오신 것을</span>{' '}
                                    <span className="text-[#71717A]">환영합니다</span>
                                </>
                            )
                        ) : (
                            <>
                                <span>인증번호를</span>{' '}
                                <span className="text-[#71717A]">확인하세요</span>
                            </>
                        )}
                    </h1>

                    <p className="mt-5 max-w-lg text-[17px] leading-relaxed text-[#A1A1AA] break-keep">
                        {step === 'phone'
                            ? isSignUp
                                ? '전화번호만으로 간편하게 가입하고 Instagram 방문자 분석을 시작하세요'
                                : '전화번호로 로그인하여 대시보드에 접속하세요'
                            : `${phone}으로 전송된 6자리 인증번호를 입력해주세요`
                        }
                    </p>
                </div>

                {/* 잠금화면 알림 루프 하이퍼프레임 (데스크톱만) — 로그인하면 받게 될 알림 미리보기 */}
                <motion.div
                    initial={reduce ? false : { opacity: 0, y: 14, rotateX: -8 }}
                    animate={{ opacity: 1, y: 0, rotateX: 0 }}
                    transition={{ duration: 0.6, delay: 0.12, ease: EASE_OUT }}
                    style={{ transformPerspective: 900 }}
                    className="mt-10 max-w-md"
                >
                    <p className="mb-3 text-[14px] text-[#A1A1AA]">
                        로그인하면 <span className="font-medium text-[#FAFAFA]">이런 알림</span>이 실시간으로 도착해요
                    </p>
                    <LockScreenHyperframe />
                </motion.div>
            </div>
        </motion.div>
    );
};
